import { t } from "@/i18n-js/instance";
import { useIsSitesEnabled } from "@/react/components/SettingsApp/Site/Pages/useIsSitesEnabled";
import { InfoBox } from "@circle-react-uikit/InfoBox";
import { Typography } from "@circle-react-uikit/Typography";
import { BlockList } from "../BlockListItems";
import { useFormBlocks } from "../Providers";
import { WebsiteBuilderNotice } from "./WebsiteBuilderNotice";

export const SidebarListView = () => {
  const { blocks, replaceBlocks } = useFormBlocks();
  const isSitesEnabled = useIsSitesEnabled();

  return (
    <div className="flex h-full flex-col p-6">
      <div className="flex-1">
        <InfoBox className="mb-7">
          {isSitesEnabled
            ? t("courses.lockscreen.only_visible_on_private")
            : t("courses.lockscreen.only_visible_on_private_old")}
        </InfoBox>
        <div className="mb-4">
          <Typography.LabelLg weight="semibold">
            {t("courses.lockscreen.page_blocks")}
          </Typography.LabelLg>
        </div>
        <BlockList blocks={blocks} onSort={replaceBlocks} />
      </div>
      {isSitesEnabled && <WebsiteBuilderNotice />}
    </div>
  );
};
